

import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {IShortCommunity} from "@/model/Community/communityInterfaces";
import ChipMixin from "@/components/shared/chips/ChipMixin";

@Component({
  mixins: [ChipMixin]
})
export default class CommunityChip extends ChipMixin {

  @Prop()
  protected item!: IShortCommunity;

  protected toUrl(): any {
    return this.itemId ? {name: 'community', params: {communityId: this.itemId}} : null;
  }

}

